/**
 * VYFINITY Premium Modular Product Page Builder
 * assets/vyfinity-product.js
 *
 * Reines Vanilla JavaScript, keine externen Abhaengigkeiten.
 * Jede Instanz von [data-vy-product] auf der Seite bekommt ein eigenes,
 * gekapseltes VyProduct-Objekt. Keine globalen Variablen ausser dem
 * einen Namespace "VyProduct" selbst (IIFE).
 */
(function () {
  "use strict";

  if (window.VyProduct) return;

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function formatWithDelimiters(cents, precision, thousands, decimalSep) {
    if (typeof cents !== "number" || isNaN(cents)) cents = 0;
    var value = (cents / 100).toFixed(precision);
    var parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? parts[0] + decimalSep + parts[1] : parts[0];
  }

  /**
   * Repliziert Shopify's money-Filter/-Formate im Client, damit die JS-seitige
   * Preisaktualisierung beim Variantenwechsel exakt zum shop.money_format
   * passt (z.B. "{{amount}}", "{{amount_with_comma_separator}}",
   * "{{amount_no_decimals}}" usw. - inkl. deutscher/europaeischer Formate).
   */
  function formatMoney(cents, format) {
    if (typeof cents !== "number") return "";
    format = format || "{{amount}}";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    var placeholder = match ? match[1] : "amount";
    var value;

    switch (placeholder) {
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0, ",", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount":
      default:
        value = formatWithDelimiters(cents, 2, ",", ".");
    }

    if (match) {
      return format.replace(placeholderRegex, value);
    }
    return format ? value + " " + format : value;
  }

  var VyProduct = function (root) {
    this.root = root;
    this.sectionId = root.getAttribute("data-section-id");
    this.form = qs(root, "[data-vy-product-form]");
    this.jsonScript = qs(root, "[data-vy-product-json]");
    this.moneyFormat = root.getAttribute("data-money-format") || "";
    this.product = null;
    this.selectedOptions = [];
    this.currentVariant = null;

    this.galleryEl = qs(root, "[data-vy-gallery]");
    this.mainSlides = [];
    this.thumbs = [];
    this.accordionMode = root.getAttribute("data-accordion-mode") || "single";

    this.init();
  };

  VyProduct.prototype.init = function () {
    if (this.jsonScript) {
      try {
        this.product = JSON.parse(this.jsonScript.textContent);
      } catch (e) {
        this.product = null;
      }
    }

    if (this.product && this.product.variants && this.product.variants.length) {
      var selectedId = this.getSelectedVariantIdFromDom();
      var initialVariant =
        this.product.variants.filter(function (v) {
          return v.id === selectedId;
        })[0] || this.product.variants[0];
      this.selectedOptions = initialVariant.options.slice();
      this.currentVariant = initialVariant;
    }

    this.bindGallery();
    this.bindOptions();
    this.bindAccordions();
    this.bindSizeGuideLinks();
    this.bindLookComplete();
    this.bindBundle();

    if (this.currentVariant) {
      this.updateForVariant(this.currentVariant, { skipUrl: true });
    }
  };

  VyProduct.prototype.getSelectedVariantIdFromDom = function () {
    var input = qs(this.root, "[data-vy-variant-id]");
    if (!input) return null;
    var val = parseInt(input.value, 10);
    return isNaN(val) ? null : val;
  };

  /* -------------------------------------------------------------- */
  /* Galerie                                                          */
  /* -------------------------------------------------------------- */

  VyProduct.prototype.bindGallery = function () {
    if (!this.galleryEl) return;
    this.mainSlides = qsa(this.galleryEl, "[data-vy-slide]");
    this.thumbs = qsa(this.galleryEl, "[data-vy-thumb]");

    this.thumbs.forEach(
      function (thumb) {
        thumb.addEventListener(
          "click",
          function () {
            this.goToMedia(thumb.getAttribute("data-vy-thumb"));
          }.bind(this)
        );
      }.bind(this)
    );

    var prevBtn = qs(this.galleryEl, "[data-vy-arrow='prev']");
    var nextBtn = qs(this.galleryEl, "[data-vy-arrow='next']");

    if (prevBtn) {
      prevBtn.addEventListener("click", this.stepMedia.bind(this, -1));
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", this.stepMedia.bind(this, 1));
    }

    var track = qs(this.galleryEl, "[data-vy-track]");
    if (track) {
      var touchStartX = null;
      track.addEventListener(
        "touchstart",
        function (e) {
          touchStartX = e.touches[0].clientX;
        },
        { passive: true }
      );
      track.addEventListener(
        "touchend",
        function (e) {
          if (touchStartX === null) return;
          var delta = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(delta) > 40) {
            this.stepMedia(delta < 0 ? 1 : -1);
          }
          touchStartX = null;
        }.bind(this),
        { passive: true }
      );
    }
  };

  VyProduct.prototype.goToMedia = function (mediaId) {
    if (!mediaId) return;
    this.mainSlides.forEach(function (slide) {
      var isActive = slide.getAttribute("data-vy-slide") === mediaId;
      slide.classList.toggle("is-active", isActive);
    });
    this.thumbs.forEach(function (thumb) {
      var isActive = thumb.getAttribute("data-vy-thumb") === mediaId;
      thumb.classList.toggle("is-active", isActive);
      thumb.setAttribute("aria-current", isActive ? "true" : "false");
    });
    var track = qs(this.galleryEl, "[data-vy-track]");
    if (track && track.getAttribute("data-vy-mobile-mode") === "swipe") {
      var activeSlide = this.mainSlides.filter(function (s) {
        return s.getAttribute("data-vy-slide") === mediaId;
      })[0];
      if (activeSlide) {
        track.scrollTo({ left: activeSlide.offsetLeft, behavior: "smooth" });
      }
    }
  };

  VyProduct.prototype.stepMedia = function (direction) {
    if (!this.mainSlides.length) return;
    var currentIndex = this.mainSlides.findIndex(function (s) {
      return s.classList.contains("is-active");
    });
    if (currentIndex === -1) currentIndex = 0;
    var nextIndex = (currentIndex + direction + this.mainSlides.length) % this.mainSlides.length;
    var nextId = this.mainSlides[nextIndex].getAttribute("data-vy-slide");
    this.goToMedia(nextId);
  };

  /* -------------------------------------------------------------- */
  /* Varianten                                                         */
  /* -------------------------------------------------------------- */

  VyProduct.prototype.bindOptions = function () {
    var self = this;
    qsa(this.root, "[data-vy-option-value]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.classList.contains("is-disabled")) return;
        var index = parseInt(btn.getAttribute("data-vy-option-index"), 10);
        var value = btn.getAttribute("data-vy-option-value");
        self.selectedOptions[index] = value;
        self.syncOptionUI();
        var variant = self.findMatchingVariant();
        if (variant) {
          self.currentVariant = variant;
          self.updateForVariant(variant, {});
        } else {
          self.updateForNoVariant();
        }
      });
    });
  };

  VyProduct.prototype.syncOptionUI = function () {
    var self = this;
    qsa(this.root, "[data-vy-option-value]").forEach(function (btn) {
      var index = parseInt(btn.getAttribute("data-vy-option-index"), 10);
      var value = btn.getAttribute("data-vy-option-value");
      var isSelected = self.selectedOptions[index] === value;
      btn.classList.toggle("is-selected", isSelected);
      btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });

    qsa(this.root, "[data-vy-option-current]").forEach(function (el) {
      var index = parseInt(el.getAttribute("data-vy-option-current"), 10);
      el.textContent = self.selectedOptions[index] || "";
    });

    if (!this.product) return;

    qsa(this.root, "[data-vy-option-value]").forEach(function (btn) {
      var index = parseInt(btn.getAttribute("data-vy-option-index"), 10);
      var value = btn.getAttribute("data-vy-option-value");
      var testOptions = self.selectedOptions.slice();
      testOptions[index] = value;
      var isAvailable = self.product.variants.some(function (v) {
        return (
          v.available &&
          v.options.every(function (optVal, i) {
            return testOptions[i] === undefined || testOptions[i] === optVal;
          })
        );
      });
      btn.classList.toggle("is-disabled", !isAvailable);
    });
  };

  VyProduct.prototype.findMatchingVariant = function () {
    if (!this.product) return null;
    var self = this;
    return (
      this.product.variants.filter(function (v) {
        return v.options.every(function (optVal, i) {
          return self.selectedOptions[i] === optVal;
        });
      })[0] || null
    );
  };

  VyProduct.prototype.updateForVariant = function (variant, opts) {
    opts = opts || {};

    qsa(this.root, "[data-vy-variant-id]").forEach(function (input) {
      input.value = variant.id;
      // Manche Shopify-Komponenten (u.a. der native Express-Checkout-Button)
      // beobachten Formularfelder ueber Standard-Events statt per Polling.
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    var priceEl = qs(this.root, "[data-vy-price-current]");
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price, this.moneyFormat);
      priceEl.classList.toggle("is-sale", variant.compare_at_price > variant.price);
    }

    var compareEl = qs(this.root, "[data-vy-price-compare]");
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price, this.moneyFormat);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    qsa(this.root, "[data-vy-submit]").forEach(
      function (btn) {
        var labelEl = qs(btn, "[data-vy-submit-label]");
        if (variant.available) {
          btn.disabled = false;
          if (labelEl) labelEl.textContent = btn.getAttribute("data-vy-label-available");
        } else {
          btn.disabled = true;
          if (labelEl) labelEl.textContent = btn.getAttribute("data-vy-label-sold-out");
        }
      }.bind(this)
    );

    if (variant.featured_media && variant.featured_media.id) {
      this.goToMedia("media-" + variant.featured_media.id);
    }

    if (!opts.skipUrl && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);
    }

    var currentBundleItem = qs(this.root, ".vy-product__bundle-item--current");
    if (currentBundleItem) {
      var bundleInput = qs(currentBundleItem, "[data-vy-bundle-variant]");
      if (bundleInput) bundleInput.value = variant.id;
      currentBundleItem.setAttribute("data-vy-bundle-price", variant.price);
      var bundlePriceEl = qs(currentBundleItem, "[data-vy-bundle-item-price]");
      if (bundlePriceEl) bundlePriceEl.textContent = formatMoney(variant.price, this.moneyFormat);
      this.recalculateBundleTotal();
    }

    this.syncOptionUI();
  };

  VyProduct.prototype.updateForNoVariant = function () {
    qsa(this.root, "[data-vy-submit]").forEach(function (btn) {
      btn.disabled = true;
      var labelEl = qs(btn, "[data-vy-submit-label]");
      if (labelEl) labelEl.textContent = btn.getAttribute("data-vy-label-sold-out");
    });
  };

  /* -------------------------------------------------------------- */
  /* Accordions                                                        */
  /* -------------------------------------------------------------- */

  VyProduct.prototype.bindAccordions = function () {
    var self = this;
    qsa(this.root, "[data-vy-accordion-trigger]").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        var item = trigger.closest("[data-vy-accordion-item]");
        var isOpen = item.getAttribute("data-open") === "true";
        if (self.accordionMode === "single" && !isOpen) {
          qsa(self.root, "[data-vy-accordion-item]").forEach(function (other) {
            if (other !== item) self.setAccordionState(other, false);
          });
        }
        self.setAccordionState(item, !isOpen);
      });
    });
  };

  VyProduct.prototype.setAccordionState = function (item, open) {
    var trigger = qs(item, "[data-vy-accordion-trigger]");
    var panel = qs(item, "[data-vy-accordion-panel]");
    var inner = qs(item, "[data-vy-accordion-panel-inner]");
    if (!trigger || !panel || !inner) return;

    item.setAttribute("data-open", open ? "true" : "false");
    trigger.setAttribute("aria-expanded", open ? "true" : "false");

    if (open) {
      panel.style.height = inner.offsetHeight + "px";
      var onEnd = function () {
        if (item.getAttribute("data-open") === "true") {
          panel.style.height = "auto";
        }
        panel.removeEventListener("transitionend", onEnd);
      };
      panel.addEventListener("transitionend", onEnd);
    } else {
      if (panel.style.height === "auto" || panel.style.height === "") {
        panel.style.height = inner.offsetHeight + "px";
      }
      requestAnimationFrame(function () {
        panel.style.height = "0px";
      });
    }
  };

  VyProduct.prototype.openAccordionByPreset = function (preset) {
    var item = qs(this.root, '[data-vy-accordion-item][data-preset="' + preset + '"]');
    if (!item) return;

    if (this.accordionMode === "single") {
      qsa(this.root, "[data-vy-accordion-item]").forEach(function (other) {
        if (other !== item) this.setAccordionState(other, false);
      }, this);
    }

    this.setAccordionState(item, true);

    window.requestAnimationFrame(
      function () {
        item.scrollIntoView({ behavior: "smooth", block: "start" });
      }.bind(this)
    );
  };

  VyProduct.prototype.bindSizeGuideLinks = function () {
    var self = this;
    qsa(this.root, "[data-vy-open-accordion]").forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        self.openAccordionByPreset(link.getAttribute("data-vy-open-accordion"));
      });
    });
  };

  /* -------------------------------------------------------------- */
  /* Cart AJAX API (gemeinsam genutzt von Look-Complete und Bundle)   */
  /* -------------------------------------------------------------- */

  function addItemsToCart(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items }),
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error((data && data.description) || "cart_add_failed");
        });
      }
      return response.json();
    });
  }

  /* -------------------------------------------------------------- */
  /* Look vervollstaendigen (Cross-Sell)                               */
  /* -------------------------------------------------------------- */

  VyProduct.prototype.bindLookComplete = function () {
    var self = this;
    qsa(this.root, "[data-vy-look-card]").forEach(function (card) {
      var select = qs(card, "[data-vy-look-variant-select]");
      var priceEl = qs(card, "[data-vy-look-card-price]");
      var addBtn = qs(card, "[data-vy-look-add]");

      if (select && select.tagName === "SELECT") {
        select.addEventListener("change", function () {
          var option = select.options[select.selectedIndex];
          if (!option) return;
          if (priceEl && option.getAttribute("data-price")) {
            priceEl.textContent = formatMoney(parseInt(option.getAttribute("data-price"), 10), self.moneyFormat);
          }
          if (addBtn) {
            var available = option.getAttribute("data-available") === "true";
            addBtn.disabled = !available;
            addBtn.textContent = available ? addBtn.getAttribute("data-label-add") : addBtn.getAttribute("data-label-sold-out");
          }
        });
      }

      if (addBtn) {
        addBtn.addEventListener("click", function () {
          if (!select) return;
          var variantId = parseInt(select.value, 10);
          if (!variantId) return;

          addBtn.disabled = true;
          var originalLabel = addBtn.textContent;

          addItemsToCart([{ id: variantId, quantity: 1 }])
            .then(function () {
              addBtn.textContent = addBtn.getAttribute("data-label-added");
              addBtn.classList.add("is-added");
              document.dispatchEvent(new CustomEvent("vy:cart:updated", { bubbles: true }));
              setTimeout(function () {
                addBtn.textContent = originalLabel;
                addBtn.classList.remove("is-added");
                addBtn.disabled = false;
              }, 2200);
            })
            .catch(function () {
              addBtn.textContent = addBtn.getAttribute("data-label-sold-out");
              setTimeout(function () {
                addBtn.textContent = originalLabel;
                addBtn.disabled = false;
              }, 2200);
            });
        });
      }
    });
  };

  /* -------------------------------------------------------------- */
  /* Bundle                                                            */
  /* -------------------------------------------------------------- */

  VyProduct.prototype.recalculateBundleTotal = function () {
    var bundle = qs(this.root, "[data-vy-bundle]");
    if (!bundle) return;
    var total = 0;
    qsa(bundle, "[data-vy-bundle-item]").forEach(function (item) {
      var price = parseInt(item.getAttribute("data-vy-bundle-price"), 10);
      if (!isNaN(price)) total += price;
    });
    var totalEl = qs(bundle, "[data-vy-bundle-total]");
    if (totalEl) totalEl.textContent = formatMoney(total, this.moneyFormat);
  };

  VyProduct.prototype.bindBundle = function () {
    var self = this;
    var bundle = qs(this.root, "[data-vy-bundle]");
    if (!bundle) return;

    this.recalculateBundleTotal();

    qsa(bundle, "[data-vy-bundle-variant-select]").forEach(function (select) {
      select.addEventListener("change", function () {
        var item = select.closest("[data-vy-bundle-item]");
        var option = select.options[select.selectedIndex];
        if (!item || !option) return;
        var price = parseInt(option.getAttribute("data-price"), 10);
        if (isNaN(price)) return;
        item.setAttribute("data-vy-bundle-price", price);
        var priceEl = qs(item, "[data-vy-bundle-item-price]");
        if (priceEl) priceEl.textContent = formatMoney(price, self.moneyFormat);
        self.recalculateBundleTotal();
      });
    });

    var addBtn = qs(bundle, "[data-vy-bundle-add]");
    if (!addBtn) return;

    addBtn.addEventListener("click", function () {
      var items = [];
      qsa(bundle, "[data-vy-bundle-item]").forEach(function (item) {
        var select = qs(item, "[data-vy-bundle-variant-select]");
        var hidden = qs(item, "[data-vy-bundle-variant]");
        var variantId = select ? parseInt(select.value, 10) : hidden ? parseInt(hidden.value, 10) : null;
        if (variantId) items.push({ id: variantId, quantity: 1 });
      });
      if (!items.length) return;

      addBtn.disabled = true;
      var originalLabel = addBtn.textContent;
      addBtn.textContent = addBtn.getAttribute("data-label-adding");

      addItemsToCart(items)
        .then(function () {
          var discountCode = addBtn.getAttribute("data-discount-code");
          if (discountCode) {
            window.location.href = "/discount/" + encodeURIComponent(discountCode) + "?redirect=/cart";
          } else {
            window.location.href = "/cart";
          }
        })
        .catch(function () {
          addBtn.textContent = addBtn.getAttribute("data-label-error");
          setTimeout(function () {
            addBtn.textContent = originalLabel;
            addBtn.disabled = false;
          }, 2200);
        });
    });
  };

  window.VyProduct = VyProduct;

  function initAll() {
    qsa(document, "[data-vy-product]").forEach(function (el) {
      if (!el._vyProductInstance) {
        el._vyProductInstance = new VyProduct(el);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var el = qs(event.target, "[data-vy-product]");
    if (el && !el._vyProductInstance) {
      el._vyProductInstance = new VyProduct(el);
    }
  });
})();
